module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_03c.2483c139.jpg";